"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyncEvent = void 0;
const flow_connect_1 = require("flow-connect");
const core_1 = require("flow-connect/core");
class SyncEvent extends core_1.Node {
    constructor() {
        super();
        this.hold = {};
    }
    setupIO(options) {
        this.addTerminals([
            { type: core_1.TerminalType.IN, name: "Event 1", dataType: "event" },
            { type: core_1.TerminalType.IN, name: "Event 2", dataType: "event" },
            { type: core_1.TerminalType.OUT, name: "synced", dataType: "event" },
        ]);
        if ((0, flow_connect_1.exists)(options.noOfEvents)) {
            for (let i = 0; i < options.noOfEvents - 2; i++) {
                this.addTerminal({ type: core_1.TerminalType.IN, dataType: "event", name: "Event " + (this.inputs.length + 1) });
            }
        }
    }
    created(options) {
        const { width = 160, name = "Sync Event", style = {} } = options;
        this.width = width;
        this.name = name;
        this.style = Object.assign({ rowHeight: 10 }, style);
        this.setupUI();
        this.setupListeners();
    }
    process() {
        let hold = [];
        for (let term of this.inputs) {
            if (this.hold.hasOwnProperty(term.id)) {
                hold.push(this.hold[term.id]);
            }
            else
                return;
        }
        this.hold = {};
        this.outputs[0].emit(hold);
    }
    setupUI() {
        this.addButton = this.createUI("core/button", { text: "Add", input: true, output: true, height: 20 });
        this.ui.append(this.addButton);
    }
    setupListeners() {
        this.inputs.forEach((terminal) => terminal.on("event", (inst, data) => {
            this.hold[inst.id] = data;
            this.process();
        }));
        this.addButton.on("click", () => {
            const newTerminal = this.addTerminal({
                type: core_1.TerminalType.IN,
                dataType: "event",
                name: "Event " + (this.inputs.length + 1),
            });
            newTerminal.on("event", (terminal, data) => {
                this.hold[terminal.id] = data;
                this.process();
            });
        });
    }
}
exports.SyncEvent = SyncEvent;
